import ModulTryoutReport from "@/modules/tryout_report/components/TryoutReport";
import ModulTryoutRating from "@/modules/tryout_report/components/TryoutRating";

export default [
    {
        path: "/tryout-report",
        name: "TryoutReport",
        component: ModulTryoutReport,
    },
    {
        path: "/tryout-rating",
        name: "TryoutRating",
        component: ModulTryoutRating,
    },
];



// WEBPACK FOOTER //
// ./src/modules/tryout_report/router/tryoutreport.js